
import { Options, Vue } from 'vue-class-component'
import VideoBackground from 'vue-responsive-video-background-player'
import ButtonPrimary from '@/components/ButtonPrimary.vue'

@Options({
    components: { VideoBackground, ButtonPrimary }
})
export default class Academy extends Vue {}
